// Core
import { Box, Text } from '@chakra-ui/react';

// Assets
import { ReactComponent as EmptyListGiveaways } from 'assets/svg/empty-list-giveaways.svg';

const EmptyList = ({ title, descriptions }) => {
  return (
  	<Box 
	    textAlign="center" 
	    py="40px" 
	    maxW={{sm: '325px'}} 
	    left="50%" 
	    position="relative" 
	    transform="translate(-50%, 0px)">
	    <EmptyListGiveaways style={{margin: '0 auto'}} />
	    <Text variant="title-md" fontSize="20px" mt="20px" pb="9px" letterSpacing="-0.4px">{ title }</Text>
	    <Text>{ descriptions }</Text>
	</Box>
  );
};

export default EmptyList;